class Autosize
  @init: () ->
    new Autosize

  constructor: () ->
    autosize($('textarea.autosize'))

export default Autosize
